export default __webpack_public_path__ + "static/media/academic-cap-icon.cb485da7.svg";